import { Connection, PublicKey } from '@solana/web3.js'
import { getParsedNftAccountsByOwner } from '@nfteyez/sol-rayz'

const nftSymbols = ['SLCAVT', 'SLCLAND', 'SLCSTAK']

export interface NFTData {
    name: string
    symbol: string
    uri?: string
    mint: string
}

export async function getNFTs(connection: Connection, owner: PublicKey) {
    try {
        const nftAccounts = await getParsedNftAccountsByOwner({
            publicAddress: owner.toBase58(),
            connection: connection,
        })

        const nfts: NFTData[] = []
        for (const nft of nftAccounts) {
            try {
                const isSoliceNFT =
                    nftSymbols.includes(nft.data.symbol) &&
                    // Backend update auth
                    nft.updateAuthority === '9xPqH4wTQYSCnUKjZuzhxac6nfRiYXoHopCq5ge1K4nF'

                if (!isSoliceNFT) continue

                const metaData = await (await fetch(nft.data.uri)).json()

                nfts.push({
                    name: nft.data.name,
                    symbol: nft.data.symbol,
                    uri: metaData.image,
                    mint: nft.mint,
                })
            } catch (error) {
                console.error('failed to get nft metadata', nft, error)
                nfts.push({
                    name: nft.data.name,
                    symbol: nft.data.symbol,
                    mint: nft.mint,
                })
            }
        }

        return nfts
    } catch (error) {
        console.error(error)
        throw error
    }
}
